/* Kintoe running lander v2: FAQ accordion and mobile sticky CTA. No dependencies.
   The countdown bar runs its own inline script, lifted from the store bar (lander-run-v2-promo). */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }

  /* FAQ: <details> animated on open AND close. One item open at a time, as on the Replo
     page. On close the item keeps [open] until the animation ends. */
  function toggle(item, opening) {
    var panel = item.querySelector('.lr-faq__panel');
    item.setAttribute('data-state', opening ? 'open' : 'closed');
    if (reduced() || !panel || !panel.animate) { item.open = opening; return; }
    var start = item.open ? panel.getBoundingClientRect().height : 0;
    if (item._lrA) { item._lrA.cancel(); item._lrA = null; }
    if (opening) item.open = true;
    var end = opening ? panel.scrollHeight : 0;
    var a = panel.animate(
      [{ height: start + 'px' }, { height: end + 'px' }],
      { duration: Math.min(420, 220 + Math.abs(end - start) / 3), easing: 'cubic-bezier(.25,.8,.25,1)', fill: 'forwards' }
    );
    item._lrA = a;
    a.onfinish = function () {
      if (item._lrA !== a) return;
      if (!opening) item.open = false;
      a.cancel();
      item._lrA = null;
    };
  }

  function initFaq(list) {
    if (list._lrF) return;
    list._lrF = true;
    var items = [].slice.call(list.querySelectorAll('details.lr-faq__item'));
    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      item.setAttribute('data-state', item.open ? 'open' : 'closed');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = item.getAttribute('data-state') !== 'open';
        if (opening && list.hasAttribute('data-single')) {
          items.forEach(function (o) { if (o !== item && o.getAttribute('data-state') === 'open') toggle(o, false); });
        }
        toggle(item, opening);
      });
    });
  }

  function init(root) {
    var i, n;
    n = root.querySelectorAll('[data-lr-faq]');
    for (i = 0; i < n.length; i++) initFaq(n[i]);
  }

  /* Mobile sticky CTA: shows once the hero has scrolled away, hides while the product
     button or the footer is on screen. */
  function initSticky() {
    var bar = document.querySelector('[data-lr-sticky]');
    if (!bar || bar._lrS || !('IntersectionObserver' in window)) return;
    bar._lrS = true;
    bar.hidden = false;
    var hero = document.querySelector('.lr-hero');
    var zones = document.querySelectorAll('[data-lr-zone]');
    var heroGone = !hero, seen = [];
    function sync() { bar.classList.toggle('is-off', !heroGone || seen.length > 0); }
    if (hero) new IntersectionObserver(function (e) { heroGone = !e[e.length - 1].isIntersecting; sync(); }).observe(hero);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var k = seen.indexOf(e.target);
        if (e.isIntersecting && k < 0) seen.push(e.target);
        if (!e.isIntersecting && k > -1) seen.splice(k, 1);
      });
      sync();
    });
    for (var i = 0; i < zones.length; i++) io.observe(zones[i]);
  }

  init(document);
  initSticky();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initSticky(); });
})();
